// Conteúdo institucional real, portado do protótipo navegável validado
// (site-mosaico-prototype.html) em 07-08/09/2026. Ver PRD-site-mosaico.md
// na pasta do projeto pra contexto completo de cada decisão de conteúdo.

export const MINISTRIES = [
  { color: "brandOrange", name: "Acolhida & Recepção", desc: "O primeiro rosto que alguém vê ao entrar — recebendo de verdade, não só sorrindo." },
  { color: "brand", name: "Louvor & Artes", desc: "Música e arte a serviço da comunhão, não do palco." },
  { color: "brandBlue", name: "Kids & Teens", desc: "Cuidando das crianças e adolescentes da família enquanto os pais estão no culto." },
  { color: "brandPurple", name: "Pequenos Grupos", desc: "Onde a igreja acontece durante a semana, em casas e mesas." },
  { color: "brandGreen", name: "Diaconia & Cuidado", desc: "Cuidado prático com quem está passando por dificuldade." },
  { color: "brandOrange", name: "Comunicação", desc: "Contando a história da Mosaico pra dentro e pra fora." },
  { color: "brandRed", name: "Reino do Bem", desc: "O braço social da igreja — ação prática de amor pra fora dos nossos muros, com quem a cidade esquece." }
];

export const SERMONS = [
  { title: "O pecado que não faz barulho — A Igreja de Sardes | Igreja Batista Mosaico", url: "https://www.youtube.com/watch?v=9A8pNTeZK_c" },
  { title: "Você já pensou em largar tudo? | Igreja Batista Mosaico", url: "https://www.youtube.com/watch?v=gz-ZRZxUIh4" },
  { title: "Deus Não vai te tirar dessa | Igreja Batista Mosaico", url: "https://www.youtube.com/watch?v=D-27I_OmXts" },
  { title: "Ocupado demais pra Deus | Igreja Batista Mosaico", url: "https://www.youtube.com/watch?v=R6ci3_FPo4I" },
  { title: "\"Não é da sua conta\" | parte 2 | Igreja Batista Mosaico", url: "https://www.youtube.com/watch?v=FWpyybGHjPY" }
];

export const SERMONS_PLAYLIST_URL = "https://www.youtube.com/playlist?list=PLscXrzCI1KRfaV_XmFmJ6wmphxPxd2Lwd";

export const PODCAST_EPISODES = [
  { ep: "124", title: "E se Deus fechar a porta? — Desconfortavelmente fiel", url: "https://www.youtube.com/watch?v=LTAjj_dqwV8" },
  { ep: "123", title: "Parece vivo, mas morreu — A fé que virou aparência", url: "https://www.youtube.com/watch?v=STfuwzBZvB4" },
  { ep: "122", title: "Cansei, mas não parei — A fé de quem quase desistiu", url: "https://www.youtube.com/watch?v=RhJVJZFlhd0" },
  { ep: "121", title: "Fé confortável — Quando Cristo não atrapalha mais nada", url: "https://www.youtube.com/watch?v=v0bHqSZHN_8" },
  { ep: "120", title: "Quanto custa sua fidelidade? — O preço da consciência", url: "https://www.youtube.com/watch?v=tmtA0lv86fc" }
];

export const PODCAST_CHANNEL_URL = "https://www.youtube.com/@RodrigoMoraesPastor/podcasts";

// Escola Biblica Mosaico -- playlist fixa do YouTube (nao muda com frequencia
// como pregacoes/podcast, entao nao tem busca via API por enquanto: soh
// esta lista mesmo, na mesma ordem da playlist).
export const SCHOOL_VIDEOS = [
  { title: "Módulo 2 - Interpretação Bíblica - Aula 04", url: "https://www.youtube.com/watch?v=HBAOYIrsB8s" },
  { title: "Módulo 2: Interpretação Bíblica Aula 3", url: "https://www.youtube.com/watch?v=SvDj3kZbFaA" },
  { title: "Módulo 2 Aula 2 interpretação bíblica - As lentes do autor", url: "https://www.youtube.com/watch?v=Pzf3amlcBdU" },
  { title: "Aula 1 Módulo 2 Introdução à Interpretação Bíblica", url: "https://www.youtube.com/watch?v=7LM0EJjobkg" },
  { title: "Aula 7 - Panorama Antigo, Inter e Neotestamentário", url: "https://www.youtube.com/watch?v=F8uXXSLutsg" },
  { title: "Aula 6: Panorama Bíblico (parte 2)", url: "https://www.youtube.com/watch?v=kIOMBjMezHc" },
  { title: "Aula 05 Panorama Intertestamentário + Panorama Novo Testamento", url: "https://www.youtube.com/watch?v=SQqPfBmqHjI" },
  { title: "Aula 4: Entendendo Melhor: Deus falando Conosco + Panorama Antigo Testamento", url: "https://www.youtube.com/watch?v=zkYkSWJXblg" },
  { title: "Escola Bíblica Mosaico | Aula 3: Panorama do Antigo Testamento (parte 2)", url: "https://www.youtube.com/watch?v=0iAoIN2VwVU" },
  { title: "Escola Bíblica Mosaico | Aula 2: Panorama do Antigo Testamento (parte 1)", url: "https://www.youtube.com/watch?v=PoqytMArH9g" },
  { title: "Escola Bíblica Mosaico - Aula 01 | Introdução Bíblica (Caio Bianchi)", url: "https://www.youtube.com/watch?v=I0HeO0nVQzI" }
];

export const SCHOOL_PLAYLIST_URL = "https://www.youtube.com/playlist?list=PLscXrzCI1KReKTNYydtcox4-q01lrdBWn";

// Eventos especiais reais (confirmados por Rodrigo no protótipo) — datas
// literais como no protótipo original; a Agenda pública também mostra os
// próximos dois domingos automaticamente (ver Eventos.jsx).
export const SPECIAL_EVENTS = [
  { title: "O Reino do Avesso — Encontro com Ceia", date: new Date(2026, 8, 6), when: "Dom · 9h e 10h", where: "Osasco", kind: "culto" },
  { title: "Encontro de Homens", date: new Date(2026, 9, 12), when: "Seg · 20h · a cada 15 dias", where: "Osasco", kind: "evento" },
  { title: "Escola Bíblica", date: new Date(2026, 8, 17), when: "Qui · 20h · a cada 15 dias", where: "Osasco", kind: "evento" },
  { title: "Encontro dos Jovens — noite de louvor e adoração", date: new Date(2026, 8, 26), when: "Sáb · 19h30", where: "Osasco", kind: "evento" }
];

// Banner promocional exibido na Agenda publica (/eventos) acima da proxima
// ocorrencia do evento correspondente (ver Eventos.jsx) -- chave precisa
// bater exatamente com o title cadastrado em /eventos.
// Numero oficial do Barnabe (agente de WhatsApp da igreja, API oficial da
// Meta) -- mesmo numero documentado no projeto do agente. Falar por aqui cai
// na mesma conversa que o Barnabe ja acompanha e registra na ficha da pessoa.
export const WHATSAPP_NUMBER = "551150283151";

export const CHANNELS = {
  igreja: [
    { icon: "youtube", name: "YouTube", handle: "Igreja Batista Mosaico", href: "https://www.youtube.com/@igrejabatistamosaico" },
    { icon: "instagram", name: "Instagram", handle: "@igrejabatistamosaico", href: "https://www.instagram.com/igrejabatistamosaico/" },
    { icon: "facebook", name: "Facebook", handle: "Igreja Batista Mosaico", href: "https://www.facebook.com/batistamosaico/" },
    { icon: "whatsapp", name: "WhatsApp Barnabé", handle: "(11) 5028-3151", href: `https://wa.me/${WHATSAPP_NUMBER}` }
  ],
  pastor: [
    { icon: "youtube", name: "YouTube", handle: "Rodrigo Moraes · Fé e Café", href: "https://www.youtube.com/@RodrigoMoraesPastor" },
    { icon: "instagram", name: "Instagram", handle: "@pr.rodrigomoraes", href: "https://www.instagram.com/pr.rodrigomoraes/" },
    { icon: "globe", name: "Site do pastor", handle: "rodrigomoraespastor.com.br", href: "https://www.rodrigomoraespastor.com.br/" }
  ]
};

export const VENUE = {
  address: "Av. dos Autonomistas, 2233 — Osasco, São Paulo",
  mapsUrl: "https://www.google.com/maps/place/Igreja+Batista+Mosaico/@-23.5387612,-46.7769588,17z/data=!3m1!4b1!4m6!3m5!1s0x94cefedff236f79b:0x4cde5f23f6362dc0!8m2!3d-23.5387661!4d-46.7743839!16s%2Fg%2F1tgn5wr5?entry=ttu",
  // Fotos por página (09/09): Home, Sobre e Contato usam cada uma sua própria
  // imagem, em vez de uma única foto de fachada compartilhada.
  photoHome: "/institucional/entrada-mosaico-home-2.jpg",
  photoSobre: "/institucional/entrada-mosaico-sobre-2.jpg",
  photoContato: "/institucional/mapa-como-chegar.jpg"
};

export const PIX = {
  key: "pix@batistamosaico.com.br",
  destinations: ["01 — Ministério Infantil", "02 — Ação Social"],
  copiaCola: "00020101021126470014br.gov.bcb.pix0125pix@batistamosaico.com.br5204000053039865802BR5922IGREJA BATISTA MOSAICO6006OSASCO62070503***63047625",
  qrImage: "/institucional/pix-qr-3.png"
};

export const CONTACT_EMAIL = "contato@batistamosaico.com.br";

export const CONTACT_PHONE = "(11) 3181-8819";
